import { Form, Formik } from "formik";
import {
  APPLY_BUTTON_STYLE,
  RESET_BUTTON_STYLE,
} from "./reportCommon";
import { DEFAULT_RC_DEPLOYMENT_FILTERS } from "./staticReportData";
import { getTodayDate } from "./ReportApi";

const RcDeploymentFilter = ({
  initialValues = DEFAULT_RC_DEPLOYMENT_FILTERS,
  circleOptions = [],
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) => onSearch?.(values)}
  >
    {({ values, setFieldValue, resetForm, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">

          {/* WARD */}
          <div className="col-md-3 mb-3">
            <label className="form-label">Ward</label>

            <select
              name="circleId"
              value={values.circleId}
              onChange={(e) =>
                setFieldValue("circleId", e.target.value)
              }
              className="form-select bg-white"
            >
              <option value="">All Wards</option>

              {circleOptions.map((circle) => (
                <option
                  key={circle.circleId}
                  value={circle.circleId}
                >
                  {circle.circleName}
                </option>
              ))}
            </select>
          </div>

          {/* FROM DATE */}
          <div className="col-md-3 mb-3">
            <label className="form-label">
              From Date
            </label>

            <input
              type="date"
              name="fromDate"
              value={values.fromDate}
              max={getTodayDate()}
              onChange={(e) =>
                setFieldValue("fromDate", e.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          {/* TO DATE */}
          <div className="col-md-3 mb-3">
            <label className="form-label">
              To Date
            </label>

            <input
              type="date"
              name="toDate"
              value={values.toDate}
              min={values.fromDate || undefined}
              max={getTodayDate()}
              onChange={(e) =>
                setFieldValue("toDate", e.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          {/* BUTTONS */}
          <div className="col-md-3 mb-3 d-flex gap-2">
            <button
              type="submit"
              style={APPLY_BUTTON_STYLE}
            >
              APPLY FILTERS
            </button>

            <button
              type="button"
              style={RESET_BUTTON_STYLE}
              onClick={() => {
                resetForm({
                  values: {
                    circleId: "",
                    fromDate: getTodayDate(),
                    toDate: getTodayDate(),
                  },
                });

                onReset?.();
              }}
            >
              RESET
            </button>
          </div>

        </div>
      </Form>
    )}
  </Formik>

);

export default RcDeploymentFilter;